module.exports = __webpack_public_path__ + "img/3-1.a4451371.png";